module.exports = __webpack_public_path__ + "img/fsi.13fd998c.png";